<template>
	<div class="ptlr-60-16 box-s" :class="{'pb-30': padShow }">
     <div class="bg_f ps_top">
				<NavList @getItem="getItem" :navList="navList"></NavList>
			</div>
      <van-list
			v-model="loading"
			:finished="finished"
			:finished-text="finishedtext"
			:immediate-check="false"
			@load="initData"
		>
			<div v-if="is_meal > 0" class="flex1 ">
				<div class="list_every pd-16 box-s mb-16" >
					<div class="flexs flex-jus">
							<div class="flexs">
								<img class="wh_46 b-radius-50 mr-10" src="../../assets/img/icon/test_q_icon.png" alt="">
								<div class="fw-500 fz-16 c1 w157 text-hide">购买套餐</div>
							</div>
							<div class="flexs bg_ec whl-74-24 flex-center fw-500 fz-12 b-radius-12 c0 orange_sty" @click="buyMeal()"> 
								点击购买
								<img class="wh_4_6 ml-5" src="../../assets/img/icon/orange_suo.png" alt="">
							</div>
					</div>
				</div>
			</div>
			<div class="list_every pd-16 box-s" :class="{ 'mb-16': index != list.length - 1 }" v-for="(item, index) in list" :key="index">
				<div class="flexs flex-jus mb-16">
						<div class="flexs">
							<img class="wh_46 b-radius-50 mr-10" src="../../assets/img/icon/history_icon.png" alt="">
							<div class="fw-500 fz-16 c1 w157 text-hide">{{item.name}}</div>
						</div>

						<div v-if="item.allow_exam > 0" class="flexs bg_ec whl-74-24 flex-center fw-500 fz-12 b-radius-12 c0" @click="startExam(item.id, item.numbers, item.minute)"> 
							开始考试
							<img class="wh_4_6 ml-5" src="../../assets/img/icon/blue_right_arrow.png" alt="">
						</div>
						<div v-else class="flexs bg_ec whl-74-24 flex-center fw-500 fz-12 b-radius-12 c0 orange_sty" @click="buyExam(item)"> 
							购买试卷
							<img class="wh_4_6 ml-5" src="../../assets/img/icon/orange_suo.png" alt="">
						</div>
				</div>

				<div class="flexs c1 fw-500 fz-14 l-h-46 plr-16 box-s bg_f9 b-radius-6">
					<div class="flex1">题目数量： {{item.numbers}}题</div>
					<div class="flex1">总分：{{item.score}}分</div>
				</div>
			</div>
		  </van-list>
			<div class="btn_contain">
				<div class="card_btn" @click="$router.push({ path: '/historymytext', query: {subject_id  } })">
					我的练习
				</div>
			</div>
		<noData v-if="show"></noData>
		<loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>

	import { testPaper, practiceExamSubject } from '@/api/api.js'
  import noData from "@/components/noData"
  import loading from "@/components/loading"
	import NavList from '@/components/navList'
	import {getShowPadding, getList, clear} from "@/utils/common.js";
	export default {
		components: {
			NavList,
			loading,
			noData
		},
		data() {
			return {
				is_meal:0,//是否有套餐
			    navList: [],
				list: [],
				padShow: false,
				show: false,
				loadFlag: false,
				loading:false,
				finishedtext: '',
				finished: false,
				page: 1,
				subject_id: ''
			};
		},
		created() {
			clear()
      		this.initEaxmList()
		},
		mounted(){
      		this.padShow = getShowPadding()
		},
		methods: {
			async initEaxmList(){
        	const res = await practiceExamSubject()
				if(res.code == 1000){
          			this.navList = res.data
					this.subject_id = this.navList[0].id
					this.initData()
				} else {
					this.$toast(res.msg)
				}
			},
			initData(){
				if(!this.subject_id){
          			return
				}
				//let res = getList(this, testPaper,  { page: this.page, subject_id: this.subject_id } )
				getList(this, testPaper,  { page: this.page, subject_id: this.subject_id },'historyQuset' )
				
			},
      
			// 点击导航
			getItem(data){
				this.is_meal = 0 //是否有套餐
				this.subject_id = data.item.id
				this.page = 1
				this.show = false
				this.loading = false,
				this.finishedtext =  '',
				this.finished =  false
				this.list = []
				this.initData()
			},
			
			// 开始考试
			startExam(calendar_topic_id, numbers, time_limit){
				if(numbers == 0 ){
          			return this.$toast('暂无题目，无法做题哦~')
				}
        		this.$router.push({ path: '/historyquest', query: { calendar_topic_id, time_limit } })
			},
			// 购买试卷
			buyExam(item){
				if(item.price <= 0){
          			return this.$toast('价格错误~')
				}
        		this.$router.push({ path: '/buytest', query: { id:item.id, name:item.name, price: item.price} })
			},
			//购买套餐
			buyMeal(){
        		this.$router.push({ path: '/meal', query: { type:1,subject_id:this.subject_id} })
			}
		}
	};
</script>
<style lang="less" scoped>
.cf {
	color: #497CFF !important;
	box-shadow: 0px 2px 4px 0px rgba(255, 255, 255, 1);
}

.his_every:last-child {
	margin-bottom: 0 !important;
}
/deep/.van-list__finished-text {
	padding-top: 12px;
  line-height: 14px;
}
/deep/.van-list__loading {
	display: none;
}
.orange_sty {
	background: #FFF4EA;
	color: #FFAB5A;
}
</style>
